import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { getUserProfile, loginUser } from '../services/api';
import usePageMeta from '../hooks/usePageMeta';
import { trackGoogleAdsConversion } from '../lib/googleAds';

function Callback() {
  usePageMeta({
    title: 'Processing Login',
    noindex: true,
  });

  const { isLoading, error } = useAuth0();
  const navigate = useNavigate();
  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    const checkUserStatus = async () => {
      try {
        // First, ensure the user is registered with the backend
        const login = await loginUser();
        if (login?.is_new_user) {
          trackGoogleAdsConversion('work_email_signup', { once: true });
        }
        
        // Then get their profile
        const data = await getUserProfile();
        
        // If user has a company and it's onboarded, go to dashboard
        if (data.company && data.user.company_id) {
          navigate('/dashboard');
        } else {
          // Otherwise, go to onboarding
          navigate('/onboarding');
        }
      } catch (err) {
        console.error('Error checking user profile:', err);
        
        // Handle access denied error (from loginUser)
        if (err.code === 'ACCESS_DENIED' || err.message === 'ACCESS_DENIED') {
          navigate('/access-denied', {
            state: {
              companyName: err.companyName,
              message: err.userMessage
            }
          });
          return;
        }
        
        // Handle 403 from API response
        if (err.response?.status === 403 && err.response?.data?.error === 'ACCESS_DENIED') {
          navigate('/access-denied', {
            state: {
              companyName: err.response.data.companyName,
              message: err.response.data.message
            }
          });
          return;
        }
        
        // If check fails, redirect to onboarding to be safe
        navigate('/onboarding');
      } finally {
        setCheckingStatus(false);
      }
    };

    if (!isLoading) {
      if (error) {
        navigate('/');
        return;
      }

      // Check user profile and company status
      checkUserStatus();
    }
  }, [isLoading, error, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: '20px' }}>
      {checkingStatus && (
        <>
          <div className="spinner"></div>
          <p>Processing login...</p>
        </>
      )}
    </div>
  );
}

export default Callback;
